import React from 'react';

const ConfirmModal = ({ show, title, message, onConfirm, onCancel, confirmText = 'Delete', cancelText = 'Cancel', danger = true, isLoading = false }) => {
  if (!show) return null;

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header" style={{ borderBottom: '1px solid #e5e7eb' }}>
            <h5 className="modal-title" style={{ fontWeight: '600' }}>{title}</h5>
            <button type="button" className="btn-close" onClick={onCancel} disabled={isLoading}></button>
          </div>
          <div className="modal-body">
            <p style={{ fontSize: '0.875rem', color: '#4b5563', marginBottom: 0 }}>{message}</p>
          </div>
          <div className="modal-footer" style={{ borderTop: '1px solid #e5e7eb' }}>
            <button 
              type="button" 
              className="btn btn-secondary"
              onClick={onCancel}
              style={{ fontSize: '0.875rem' }}
              disabled={isLoading}
            >
              {cancelText}
            </button>
            <button 
              type="button" 
              className={`btn ${danger ? 'btn-danger' : 'btn-primary'}`}
              onClick={onConfirm}
              style={{ fontSize: '0.875rem' }}
              disabled={isLoading}
            >
              {isLoading && <span className="spinner-border spinner-border-sm me-2" role="status"></span>}
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
